import React from "react"

// Utility functions for handling review data in Builder v2 components

/**
 * Get review display data for a practice
 * @param {Object} practice - The practice object
 * @param {boolean} forceShowReviews - Force show reviews regardless of rating threshold
 * @returns {Object} - Object containing review count, average rating, and whether to show reviews
 */
export const getReviewDisplayData = (practice, forceShowReviews = false) => {
  if (!practice) {
    return {
      showReviews: false,
      reviewCount: 0,
      averageRating: 0,
      hasValidReviews: false
    }
  }

  const reviewsCount = practice.reviewsCount || 0
  const averageRating = practice.reviewsAverage || 0

  // Only show reviews if there are reviews and average rating is 4+ stars
  const hasValidReviews = reviewsCount > 0 && averageRating >= 4.0

  return {
    showReviews: forceShowReviews ? reviewsCount > 0 : hasValidReviews,
    reviewCount: reviewsCount,
    averageRating: averageRating,
    hasValidReviews
  }
}

/**
 * Render star rating component
 * @param {number} rating - The rating (0-5)
 * @param {string} className - Additional CSS classes
 * @returns {JSX.Element} - Star rating component
 */
export const renderStarRating = (rating, className = "h-4 w-4") => {
  const fullStars = Math.floor(rating)
  const hasHalfStar = rating % 1 >= 0.5

  return (
    <div className="flex items-center gap-1">
      {[...Array(5)].map((_, i) => {
        let starClass = "text-gray-300"
        if (i < fullStars) {
          starClass = "text-yellow-400"
        } else if (i === fullStars && hasHalfStar) {
          starClass = "text-yellow-400"
        }

        return (
          <svg key={i} className={`${className} ${starClass}`} fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        )
      })}
    </div>
  )
}
